import type { SVGProps } from 'react';
const SvgReceiptLong = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#receipt_long_svg__a)">
      <path d="M19.5 3.5 18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2v14H3v3c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V2l-1.5 1.5ZM19 19c0 .55-.45 1-1 1s-1-.45-1-1v-3H8V5h11v14Z" />
      <path d="M15 7H9v2h6V7ZM18 7h-2v2h2V7ZM15 10H9v2h6v-2ZM18 10h-2v2h2v-2Z" />
    </g>
    <defs>
      <clipPath id="receipt_long_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgReceiptLong;
